<script>
import InputText from "@/components/InputText.vue";

export default {
    extends: InputText,
    name: "InputTextArea",
};
</script>

<template>
    <textarea :class="klass" v-bind="$attrs" v-on="$listeners" />
</template>

<style lang="scss" scoped>
@import "@/style/mixins/input";

textarea {
    @include input-mixin;
    resize: none;
}
</style>
